export enum SubscriptionTypeEnum {
  AMEDIATIKA = 'amediateka',
  WINK = 'wink',
  START = 'start',
  STANDART = 'standart',
  PREMIUM = 'premium',
  SETANTA = 'setanta',
  UZVIDEO = 'uz-video',
  ONLINETV = 'online-tv',
}

export enum AmountTypeEnum {
  PERCENT = 'percent',
  ABSILUTE = 'absolute',
}
